<template>
    <a-input-search
      v-model:value="value"
      placeholder="输入自定义链接，例：https://www.baidu.com"
      @search="comfirm"
    >
    <template #enterButton>
        <a-button type="primary" >
          确认
        </a-button>
      </template>
    </a-input-search>
</template>
<script>
import { toRefs,reactive } from 'vue'
export default {
  name:'customize',
  setup(porps,{emit}){
    const data = reactive({
      value:''
    })
    const comfirm=()=>{
       emit('success',data.value)
    }
    return{
      ...toRefs(data),
      comfirm
    }
  }
}
</script>

<style lang="less" scoped>

</style>